import React, { useEffect, useSyncExternalStore } from 'react';
import styled from 'styled-components';
import ChatWindow from './ChatWindow';
import {
  ALLOW_ANY_PARENT_ORIGIN,
  ALLOWED_PARENT_ORIGINS,
  getConfig,
  subscribe
} from './config';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    sans-serif;
`;

const Header = styled.header`
  background-color: #2c3e50;
  color: white;
  padding: 15px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
`;

const ContentArea = styled.div`
  /* Take the remaining space instead of subtracting a hardcoded header
     height, which drifts whenever the header styling changes. */
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

function App() {
  const config = useSyncExternalStore(subscribe, getConfig);

  useEffect(() => {
    const isEmbedded = (() => {
      try {
        return window.self !== window.top;
      } catch {
        return true;
      }
    })();

    if (!isEmbedded) return;

    // Announce readiness. IFRAME_READY carries no secret (it is only a
    // "you may configure me now" ping), so when any origin is allowed we can
    // broadcast with '*'; otherwise address each allowed parent explicitly.
    // Configuration itself is validated in ChatWindow.
    try {
      if (ALLOW_ANY_PARENT_ORIGIN) {
        window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
      } else {
        ALLOWED_PARENT_ORIGINS.forEach((origin) => {
          window.parent.postMessage({ type: 'IFRAME_READY' }, origin);
        });
      }
    } catch {
      // Parent is gone or blocked; nothing useful to do.
    }
  }, []);

  return (
    <AppContainer>
      <Header>
        <Title>{config.headerTitle}</Title>
      </Header>
      <ContentArea>
        <ChatWindow />
      </ContentArea>
    </AppContainer>
  );
}

export default App;
